import { PaymentStatusCode } from '../models/Order';

function displayPaymentStatus(code: PaymentStatusCode) {
  switch (code) {
  case 'refund':
    return '已退款';
  case 'success':
    return '交易成功';
  default:
    return code;
  }
}

export default displayPaymentStatus;
